module.exports = __webpack_public_path__ + "static/media/irish cream.8ce43d1a.JPG";